import Apify from '@module/apify';

export default Apify({
  sendFeedbackForTransfer: {
    path: '/api/v4/comments/transfer/{transferId}',
    method: 'POST',
    pathExt: true,
  },
});
